import ChatButtonAndDropdown from './ChatButtonAndDropdown';
import connect from './ChatButtonAndDropdown.container';
import NotesButtonAndDropdown from '../NotesButtonAndDropdown';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    chat_to_notes: NotesButtonAndDropdown
})(connect(ChatButtonAndDropdown));
